import { map, get }                             from 'lodash';
import React, { PropTypes }                     from 'react';
import PlaylistItem                             from 'components/player/playlist_item';
import SimpleSlider                             from 'react-slick';
import { getParams, isIpad, getImageServer }    from 'utils/util';
import cx                                       from 'classnames';
import TrackingActions                          from 'actions/tracking_actions';
import VideoActions                             from 'actions/video_actions';


export default React.createClass({
  displayName: 'MedscapeTV.Chapters',
  propTypes: {
                 viewed: PropTypes.object,
                  index: PropTypes.number,
                  title: PropTypes.string,
               chapters: PropTypes.array,
              headerURL: PropTypes.string,
               children: PropTypes.string,
               duration: PropTypes.number,
         hasMobileStyle: PropTypes.bool,
               showMore: PropTypes.bool,
                  video: PropTypes.object,
    videoUrlFragmentUrl: PropTypes.string
  },
  getDefaultProps() {
    let index = 0;
    if(typeof getParams().startVideo !== 'undefined') {
      index = getParams().startVideo - 1;
    }
    return {
      chapters: [],
        viewed: {},
         index: index,
      isiLinks: []
    };
  },
  getInitialState() {
    let index = 0;
    if(typeof getParams().startVideo !== 'undefined') {
      index = getParams().startVideo - 1;
    }
    return {
        index: index,
       viewed: this.props.viewed,
      enabled: true
    };
  },
  shouldComponentUpdate(nextProps) {
    if(this.state.enabled === false) {
      return false;
    }
    if(nextProps.showMore !== this.props.showMore) {
      return true;
    }
    if(nextProps.index !== this.props.index) {
      return true;
    } else if (nextProps.chapters !== this.props.chapters) {
      return true;
    } else {
      return false;
    }
  },
  componentDidUpdate() {
    const breakpoint = get(this, 'refs.slider.state.breakpoint', 4);
    const breakPointsToSlideNumbers = {
         400 : 2,
         767 : 3,
        1024 : 4
    },
       visibleSlides = breakPointsToSlideNumbers[breakpoint] || 4,
          indexStart = this.state.index,
            indexEnd = this.state.index + visibleSlides,
    incrementedIndex = this.props.index + 1;
    if (!(incrementedIndex >= indexStart && incrementedIndex <= indexEnd)) {
      setTimeout(()=>{ this.refs.slider.slickGoTo(this.props.index);}, 500);
    }
  },
  forceRepaint() {
    this.refs.slider.slickGoTo(this.props.index - 1);
    this.refs.slider.slickGoTo(this.props.index);
  },
  hasViewed(index) {
    return this.props.viewed[index];
  },
  enableClick(index) {
    if(this.state.index < index) {
      TrackingActions.slideNavigate('next');
    } else if(this.state.index > index) {
      TrackingActions.slideNavigate('prev');
    }
    this.setState({
      enabled: true,
        index: index
    });
  },
  disableClick() {
    this.setState({
      enabled: false
    });
  },
  extLink() {
    window.trackingEnabled = false;
    TrackingActions.externalLink();
    VideoActions.pause();
  },
  renderChapter(chapter, i) {
    const isSelected = this.props.videoUrlFragmentUrl.endsWith(chapter.videoUrlFragment),
           hasViewed = this.hasViewed(i);
    if(typeof chapter.source === 'undefined') {
      const thumbNail = get(chapter, 'thumbnail', ''),
                title = get(chapter, 'title', ''),
             videoTag = get(chapter, 'videoTag', ''),
            csClasses = cx({
                              'thumbnail-btn': true,
                          'coming-soon-thumb': true
                        });
          let placeHolder = null;
          if(chapter.isIfi === true) {
            placeHolder = (<a key={i} href={chapter.ifiHref} target="_blank" onClick={this.extLink}>
                            <div className="video-player-playlist-item">
                              <img className={ csClasses } src={`${ getImageServer() }/${ thumbNail }`} />
                              <div className="video-title">
                                <div className="advertisment">{ videoTag }</div>
                                <div className="video-title">{ title }</div>
                              </div>
                            </div>
                          </a>);
          } else {
            placeHolder = (<div key={i}>
                            <div className="video-player-playlist-item">
                                <img className={ csClasses } src={`${ getImageServer() }/${ thumbNail }`} />
                                <div className="video-title">
                                  <div className="coming-soon">COMING SOON</div>
                                  <div className="low-light">{ videoTag }</div>
                                  <div className="video-title">{ title }</div>
                                </div>
                             </div>
                            </div>);
          }
      return placeHolder;
    } else {
      if(this.props.hasMobileStyle) {
        return  (<PlaylistItem
                  key={`${i}-pl`}
                  hasViewed={ hasViewed }
                  isSelected={ isSelected }
                  index={ i }
                  video={ chapter }
                  isVisible= { chapter.isVisible }
                  enabled={ this.state.enabled }
                />);
      } else {
        return (<div key={`${i}-pldiv`}><PlaylistItem
           hasViewed={ hasViewed }
           isSelected={ isSelected }
           index={ i }
           video={ chapter }
           isVisible= { chapter.isVisible }
           enabled={ this.state.enabled }
          key={`pl${i}`}
         /></div>);
      }
    }
  },
  render() {
    const visibleChapters = this.props.chapters.filter(chapter => chapter.isVisible !== false);
    let chapters = map(visibleChapters, this.renderChapter, this);
    const sliderClasses = cx({
                'slider': true,
          'display-more': this.props.showMore
        }),
          settings = {
                      dots: false,
                  infinite: false,
                     speed: 300,
              slidesToShow: 4,
            slidesToScroll: 4,
                centerMode: false,
                       rtl: false,
              beforeChange: this.disableClick,
               afterChange: this.enableClick,
                 draggable: !this.props.hasMobileStyle && isIpad(),
                responsive: [
                             { breakpoint: 400,  settings: { slidesToShow: 2, slidesToScroll: 2 } },
                             { breakpoint: 767,  settings: { slidesToShow: 3, slidesToScroll: 3 } },
                             { breakpoint: 1024, settings: { slidesToShow: 4, slidesToScroll: 4 } },
                            ],
        };
    if(!this.props.hasMobileStyle && chapters.length !== 0) {
        chapters = (<SimpleSlider ref="slider" {...settings}>
                      { chapters }
                    </SimpleSlider>);
    }
    const numberOfEpisodes = this.props.chapters.filter(function(video) { return (video.isIndexed === true); }).length;
    return (<div className="slider-wrap"><div className={sliderClasses}>
              <div className="episode-title">EPISODES ({numberOfEpisodes})</div>
              { chapters }
           </div></div>);
  }
});



/** WEBPACK FOOTER **
 ** ./modules/components/medscape_tv/chapters.jsx
 **/